import { IShowCheckProjectsParams } from 'src/models';
import CheckChangeProjects from 'src/components/CheckChangeProjects/CheckChangeProjects';

export default {
    CheckChangeProjectsComponent: null,

    dispose() {
        if (this.CheckChangeProjectsComponent) {
            this.CheckChangeProjectsComponent.dispose();
        }
        this.CheckChangeProjectsComponent = null;
    },

    show(params: IShowCheckProjectsParams) {
        if (!this.CheckChangeProjectsComponent) {
            this.CheckChangeProjectsComponent = new CheckChangeProjects({
                source: '<x-check-change-projects></x-check-change-projects>'
            });
            this.CheckChangeProjectsComponent.attach(document.getElementById('app'));
        }
        this.CheckChangeProjectsComponent.show(params)
    }
};
